import { MentorDataDashboard } from "@/components/mentor-data-dashboard";

interface PerformanceTabProps {
  mentorId: string;
}

export function PerformanceTab({ mentorId }: PerformanceTabProps) {
  return <MentorDataDashboard mentorId={mentorId} embedded />;
}
